<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Contacto" resource="contactos" primaryKey="idcontacto" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import ContactoService from "@/services/contacto.service";
import { contacto } from "@/models/contacto";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: contacto,
      service: ContactoService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        ContactoService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
